import { Field, Label, Input, Description } from '@headlessui/react';
import PropTypes from 'prop-types';

export const FormField = ({ id, label, description, type, value, placeholder, autoComplete, onChange }) => {
  return (
    <Field>
      <Label htmlFor={id} className="text-sm/6 font-medium text-[#7BCDBA]">{label}</Label>
      <Description className="text-sm/6 text-gray-400">{description}</Description>
      <Input
        id={id}
        name={id}
        type={type}
        value={value}
        placeholder={placeholder}
        required
        autoComplete={autoComplete}
        onChange={onChange}
        className="mt-0 block w-full sm:w-96 border-b border-white/10 bg-transparent py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#7BCDBA]/50 transition-colors"
      />
    </Field>
  );
};

FormField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
